import { memo, useEffect, useRef } from 'react';
import {
  ErrorMessageWrapper,
  PropertyErrorDescription,
  ReloadButton,
  ReloadButtonIcon,
  WarningIconImage,
} from './ErrorMessage.styles';

export type ErrorMessageProps = {
  message?: string;
  dataTestId?: string;
  isShowRefreshButton?: boolean;
  onClick?: () => void;
};

export const ErrorMessage = memo((props: ErrorMessageProps) => {
  const { message, onClick, isShowRefreshButton = false, dataTestId = 'ErrorMessage-wrapper' } = props;

  const previousMessage = useRef<string | undefined>(message);

  useEffect(() => {
    previousMessage.current = message;
  }, [message]);

  return (
    <ErrorMessageWrapper data-testid={dataTestId}>
      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '6px' }}>
        <WarningIconImage />
        {/* oxlint-disable-next-line react/refs -- deliberately reads the last-committed value; using state instead would remove the intended one-render lag */}
        <PropertyErrorDescription>{message ?? previousMessage.current}</PropertyErrorDescription>
      </div>

      {isShowRefreshButton && (
        <ReloadButton onClick={onClick}>
          <ReloadButtonIcon />
          <span>reload</span>
        </ReloadButton>
      )}
    </ErrorMessageWrapper>
  );
});

ErrorMessage.displayName = 'ErrorMessage';
